import { Link } from "react-router";
import { all_routes } from "../../router/all_routes";

interface Props {
    activeTab: 'AppSettings' | 'WebsiteSettings' | 'BillingSettings';
}

const CommonTabMenu = ({ activeTab }: Props) => {
    const routes = all_routes;


    return (
        <ul className="nav nav-tabs nav-tabs-solid bg-transparent border-bottom mb-3">
            <li className={`nav-item`}>
                <Link className={`nav-link ${activeTab === 'WebsiteSettings' ? 'active' : ''}`} to={routes.cloudStorageSettings}>
                    <i className="ti ti-world me-2" />
                    Website Settings
                </Link>
            </li>
            <li className={`nav-item`}>
                <Link className={`nav-link ${activeTab === 'AppSettings' ? 'active' : ''}`} to={routes.featureControl}>
                    <i className="ti ti-settings me-2" />
                    App Settings
                </Link>
            </li>
            <li className={`nav-item`}>
                <Link className={`nav-link ${activeTab === 'BillingSettings' ? 'active' : ''}`} to={routes.taxSettings}>
                    <i className="ti ti-calculator me-2" />
                    Billing Settings
                </Link>
            </li>

        </ul>
    )
}

export default CommonTabMenu;